import { DataGrid } from '@mui/x-data-grid';

import { getAnalyticsTableColumnData, SkillsMatrixTable } from '../helper/analyticsTableHelper';

import { IJobTitleCount, ISkillsCount } from './SkillsMatrix';

interface IAnalyticsTableProp {
  tableType: SkillsMatrixTable;
  data: ISkillsCount[] | IJobTitleCount[];
}

export default function AnalyticsCountTable({ tableType, data }: IAnalyticsTableProp) {
  const columns = getAnalyticsTableColumnData(tableType);

  return (
    <DataGrid
      rows={data as any}
      columns={columns}
      pageSize={10}
      rowHeight={40}
      rowsPerPageOptions={[10]}
      disableSelectionOnClick
    />
  );
}
